export default __webpack_public_path__ + "static/PoweredByImage-bb780d316e42c961f08582f6a3119f3e.png";